module.exports = __webpack_public_path__ + "img/iq.0885ff7d.svg";